




















import { Component } from "vue-property-decorator";
import BasePage from "../base/BasePage";
import Header from "./Home/Header.vue";
import NewBusiness from "./Home/NewBusiness.vue";
import ExistingBusiness from "./Home/ExistingBusiness.vue";
import UntrackedBusiness from "./Home/UntrackedBusiness.vue";
import { Pages } from "@/enums/Pages";
import { BreadCrumb } from "@/store/modules/GlobalStore";
import { clientsStore } from "@/store/modules/ClientStore";
import { opportunityStore } from "@/store/modules/OpportunityStore";
import { Route } from "vue-router";
import { NullableString } from "@/code/Types";
import { inForceStore } from "@/store/modules/InForceStore";
import moment from "moment";

@Component({
  components: {
    Header,
    NewBusiness,
    ExistingBusiness,
    UntrackedBusiness,
  },
})
export default class extends BasePage {
  page = Pages.CLIENT;
  title = "Client";
  breadCrumbs = [new BreadCrumb("Client")];
  panel = [0, 1, 2, 3];

  async beforeRouteEnter(
    to: Route,
    from: Route,
    next: () => void
  ): Promise<void> {
    await clientsStore.select(to.params.id);
    await opportunityStore.getByClientId(to.params.id);
    await inForceStore.inforceCases({
      firstName: clientsStore.current.clientFirstName,
      lastName: clientsStore.current.clientLastName,
      dateOfBirth: moment(clientsStore.current.clientDateOfBirth).format(
        "MM/DD/YYYY"
      ),
    });
    next();
  }

  created(): void {
    this.title = `Client Details: ${this.clientName}`;
    this.breadCrumbs.push(new BreadCrumb(String(this.clientName)));
  }

  get clientName(): NullableString {
    return `${clientsStore.current.clientFirstName} ${clientsStore.current.clientLastName}`;
  }
}
